export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const GET_LOGIN_USER = 'GET_LOGIN_USER';
export const LOGOUT='LOGOUT';
export const GET_DUMMY_CITIES='GET_DUMMY_CITIES';
export const SHOW_PROFILE_CANDIDATE='SHOW_PROFILE_CANDIDATE';